'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

/**
 * SelectOptgroup component, used to display a native optgroup within a select.
 *
 * @example
 * <Select>
 *   <SelectOptgroup label='Group 1'>
 *     <SelectOption value='1'>Option 1</SelectOption>
 *     <SelectOption value='2'>Option 2</SelectOption>
 *   </SelectOptgroup>
 * </Select>
 */
const SelectOptgroup = forwardRef(function SelectOptgroup({ asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'optgroup';
    return jsx(Component, { ...rest, ref: ref });
});

export { SelectOptgroup };
